module.exports = __webpack_public_path__ + "img/tips-shower-icon.5aa81348.svg";